var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-dots"},_vm._l((_vm.pages),function(page){return _c('div',{key:page,staticClass:"swiper-dots__dot",class:_vm.getDotClasses(page),on:{"click":function($event){return _vm.$emit('navigate-to', page)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }